import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forYou = ['Sientes que tienes un propósito pero no sabes cómo encontrarlo', 'Llevas tiempo esperando y empiezas a dudar', 'Te comparas con otras mujeres que parecen "más avanzadas"', 'Oras, pero sientes que falta algo', 'Quieres más que inspiración — quieres revelación real'];
const notForYou = ['Buscas respuestas fáciles sin compromiso personal', 'No estás dispuesta a ser honesta contigo misma delante de Dios', 'Quieres un libro para la vitrina, no para la transformación'];
export function ForYou() {
  return <section className="py-10 px-5" data-id="element-168">
      <div className="max-w-lg mx-auto space-y-8" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-170">
          <h2 className="font-serif text-xl text-cream-100 mb-4 border-b border-gold-500/20 pb-3" data-id="element-171">
            Este devocional es para ti si...
          </h2>
          <ul className="space-y-2.5" data-id="element-172">
            {forYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-[14px] text-cream-300/90 font-light leading-snug" data-id="element-173">
                <Check size={16} className="text-green-400 flex-shrink-0 mt-0.5" data-id="element-174" />
                <span data-id="element-175">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-176">
          <h2 className="font-serif text-xl text-cream-100/70 mb-4 border-b border-red-500/20 pb-3" data-id="element-177">
            Este devocional NO es para ti si...
          </h2>
          <ul className="space-y-2.5" data-id="element-178">
            {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-[14px] text-cream-300/60 font-light leading-snug" data-id="element-179">
                <X size={16} className="text-red-400/70 flex-shrink-0 mt-0.5" data-id="element-180" />
                <span data-id="element-181">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}